module.exports = __webpack_public_path__ + "static/icons/icon-no-banners-ad2ab1522f8c771147b3042e919011a4.svg";